import { gql } from '@apollo/client';

export interface MergeMembers {
  organizationId: number;
  primaryMemberId: number;
  duplicateMemberIds: [number];
}

export interface Data {
  mergeMembers: any;
}

export const MUTATION = gql`
  mutation MergeMembers($organizationId: Int!, $primaryMemberId: Int!, $duplicateMemberIds: [Int]!) {
    mergeMembers(
      organizationId: $organizationId
      primaryMemberId: $primaryMemberId
      duplicateMemberIds: $duplicateMemberIds
    ) {
      id
    }
  }
`;
